import { getWindow } from './getWindow';

/**
 * Создает строку с параметрами запроса из window.location.search
 * и добавляет их к указанному URL.
 *
 * @param {string} url - Базовый URL-адрес, к которому нужно добавить параметры.
 * @returns {string} - URL с добавленными параметрами.
 */
export const buildUrlWithParams = (url: string) => {
    const window = getWindow();
    if (!window) {
        return url;
    }

    const params = new URLSearchParams(window?.location.search);
    const paramString = params.toString();
    const separator = url.includes('?') ? '&' : '?';

    return paramString ? `${url}${separator}${paramString}` : url;
};
